import { createFeatureSelector, createSelector } from "@ngrx/store";

export const selectorTask = createSelector(
    createFeatureSelector('task'),
    (state: any) => state
);